import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/services/api-client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying a 401/403/404 just delays the error the user needs to see.
        // Only transient failures (5xx, network) are worth another attempt.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/** Central key registry, so cache invalidation cannot drift from the queries. */
export const queryKeys = {
  currentUser: ["current-user"] as const,
  groups: ["groups"] as const,
  myGroup: ["groups", "mine"] as const,
  group: (groupId: string) => ["groups", groupId] as const,
  joinRequests: (groupId: string) => ["groups", groupId, "join-requests"] as const,
  messages: (groupId: string) => ["groups", groupId, "messages"] as const,
  pickupAreas: ["pickup-areas"] as const,
  adminUsers: ["admin", "users"] as const,
  adminStats: ["admin", "stats"] as const,
  adminAreas: ["admin", "pickup-areas"] as const,
  // Under "groups", so every invalidateGroups() refreshes the admin list too.
  adminGroups: ["groups", "admin"] as const,
};

/** Everything group-shaped: memberships and statuses ripple across all of it. */
export function invalidateGroups(): void {
  void queryClient.invalidateQueries({ queryKey: queryKeys.groups });
}
